import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=0d5aa6c0&scoped=true&"
import script from "./AboutSection.vue?vue&type=script&lang=ts&"
export * from "./AboutSection.vue?vue&type=script&lang=ts&"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=0d5aa6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5aa6c0",
  null
  
)

export default component.exports